import Menu           from 'antd/lib/menu';
import React          from 'react';
import { Link }       from 'react-router-dom';
import { useMatches } from 'react-router-dom';

export type NavigationItem = {
	key?: string;
	label: React.ReactNode;
	icon?: React.ReactNode;
	link?: string;
	onClick?: () => void;
	children?: NavigationItem[],
	style?: React.CSSProperties;
}

const getMenuItem = (item: NavigationItem) => {
	// Nous souhaitons avoir '/url/... ' ceci nous permet d'avoir la couleur du background du menu actif.
	// Exemple: si item.link = 'mails/split', alors nous retournons '/mails/split'
	const link = !item.link?.startsWith('/', 0) ? `/${item.link}` : item.link;

	return {
		key: link,
		...item,
		label: item.link ? <Link to={item.link}>{item.label}</Link> : item.label,
		children: item.children ? getToMenuItems(item.children) : undefined,
		style: { ...item.style, minHeight: 'fit-content' },
	};
};

const getToMenuItems = (items: NavigationItem[]): any => {
	return items.map((item) => getMenuItem(item));
};

export type NavigationProps = {
	items: NavigationItem[],
	style?: React.CSSProperties,
	collapsed?: boolean,
}

export default function Navigation(props: NavigationProps) {
	const matches = useMatches();
	const [openKeys, setOpenKeys] = React.useState<string[]>([]);
	const items = getToMenuItems(props.items);

	const selectedKeys = (() => {
		if (!matches.length) return undefined;

		const key = matches.at(-1)?.pathname || '';

		if (!key) return undefined;

		// Pour un chemin à un seul segment comme par exemple /subscription, la regex plus bas réduirait la clé à '/' et surlignerait l'accueil à tort.
		if (key.split('/').filter(Boolean).length <= 1) return [key];

		return [
			key,
			key.replace(/\/[^/]+$/, '/split'),
			key.replace(/\/[^/]+$/, '/'),
		];
	})();

	React.useEffect(() => {
		const toOpenKeys = props.collapsed === false
			? items.filter((item: NavigationItem) => item.children?.some(
				child => child.key && selectedKeys?.includes(child.key)
			)).map((item: NavigationItem) => item.key)
			: [];

		setOpenKeys(toOpenKeys);
	}, [props.collapsed]);

	return (
		<Menu
			items={items}
			mode="inline"
			onOpenChange={keys => {
				setOpenKeys(keys);
			}}
			openKeys={openKeys}
			selectedKeys={selectedKeys}
			style={props.style}
			theme="dark"
		/>
	);
}
